import { faCopy } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useSnackbarContext } from '@/data/contexts/SnackbarContext';
import { cn } from '@/utils/cn';

interface CopyButtonProps {
  value: string;
  label: string;
  className?: string;
}

export const CopyButton = ({ value, label, className }: CopyButtonProps) => {
  const { t } = useTranslation();
  const { showSuccess, showError } = useSnackbarContext();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          className={cn('h-6 w-6 shrink-0 text-muted-foreground', className)}
          aria-label={label}
          onClick={(event) => {
            event.stopPropagation();
            navigator.clipboard
              .writeText(value)
              .then(() => showSuccess(t('common.copied_to_clipboard')))
              .catch(() => showError(t('common.copy_failed')));
          }}
        >
          <FontAwesomeIcon icon={faCopy} className="h-3 w-3" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
};
